import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "d-flex flex-wrap mb-4" }
const _hoisted_7 = { class: "col-md-6 mb-3" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_10 = ["src", "onClick"]
const _hoisted_11 = { class: "ms-1" }
const _hoisted_12 = { class: "table table-sm" }
const _hoisted_13 = { class: "col-md-6 mb-3" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_16 = ["src", "onClick"]
const _hoisted_17 = { class: "ms-3" }
const _hoisted_18 = { class: "table table-sm" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "table" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "table" }
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "table" }
const _hoisted_26 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_27 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = { class: "modal-body text-center" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Détails emplacement", -1)),
              _createVNode(_component_router_link, {
                to: "/liste-emplacement",
                class: "btn btn-primary transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                  _createElementVNode("span", { class: "position-relative" }, null, -1),
                  _createTextVNode("Retour ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "fw-bold" }, "Locataire", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    (_ctx.locataireMedia.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locataireMedia, (media) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: media.nomMedia,
                              src: _ctx.getUrlApiForFiles('Usagers', media.nomMedia),
                              alt: "Photo Locataire",
                              class: "img-thumbnail rounded me-2 shadow",
                              style: {"width":"170px","height":"170px","cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.openModal(media.nomMedia))
                            }, null, 8, _hoisted_10))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("table", _hoisted_12, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Nom:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.nom) + " " + _toDisplayString(_ctx.emplacement?.locataire?.prenom), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "NPI:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.npi), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "IFU:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.ifu), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Téléphone:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.tel), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("p", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Activité:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.emplacement?.locataire?.activite), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "fw-bold" }, "Exploitant", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    (_ctx.exploitantMedia.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exploitantMedia, (media) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: media.nomMedia,
                              src: _ctx.getUrlApiForFiles('Usagers', media.nomMedia),
                              alt: "Photo Exploitant",
                              class: "img-thumbnail rounded me-2 shadow",
                              style: {"width":"170px","height":"170px","cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.openModal(media.nomMedia))
                            }, null, 8, _hoisted_16))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Nom:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.exploitant?.nom) + " " + _toDisplayString(_ctx.emplacement?.exploitant?.prenom), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "NPI:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.exploitant?.npi), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "IFU:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.exploitant?.ifu), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Téléphone:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.exploitant?.tel), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("p", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Activité:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.emplacement?.exploitant?.activite), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("table", _hoisted_21, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Ancien Code:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.ancienne_ref), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Nouveau Code:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.ncode_emp), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Taxe mensuelle:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.montant_location) + " F CFA", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Secteur:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.secteur?.libelle_secteur || "Non défini"), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("table", _hoisted_23, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Locataire:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.full_name), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Exploitant:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.exploitant?.full_name), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[21] || (_cache[21] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Type Emplacement:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.type_emplacement?.libelleTypeEmp || "Non défini"), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[22] || (_cache[22] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Activité:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.activite), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", _hoisted_25, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("td", null, [
                        _createElementVNode("strong", null, "Plus de détail activité:")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.emplacement?.locataire?.new_activite), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[24] || (_cache[24] = _createElementVNode("h5", { class: "modal-title" }, "Agrandir l'image", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("img", {
                  src: _ctx.getUrlApiForFiles('Usagers', _ctx.selectedImage),
                  class: "img-fluid"
                }, null, 8, _hoisted_31)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32))
      : _createCommentVNode("", true)
  ], 64))
}